import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=00efa226&scoped=true"
import script from "./VTextarea.vue?vue&type=script&lang=js"
export * from "./VTextarea.vue?vue&type=script&lang=js"
import style0 from "./VTextarea.vue?vue&type=style&index=0&id=00efa226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efa226",
  null
  
)

export default component.exports